module.exports = {
  title: 'separator',
  icon: "<i class='vw-separator'></i>"
}



// WEBPACK FOOTER //
// ./src/components/Shared/editor/modules/separator.js